
import React from 'react';
import Navbar from '@/components/ui-elements/Navbar';

interface NotLoggedInLayoutProps {
  children: React.ReactNode;
  showNavbar?: boolean;
}

const NotLoggedInLayout: React.FC<NotLoggedInLayoutProps> = ({ 
  children, 
  showNavbar = true 
}) => {
  return (
    <div className="min-h-screen flex flex-col">
      {showNavbar && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

export default NotLoggedInLayout;
